/** @format */

import { takeLatest } from "redux-saga/effects";
import { TActionType } from "../declarations/actionTypes";
import { sagaJustificativeStatusList } from "../sagas/sagasJustificativeStatuses";

export function* watcherJustificativeStatuses(): unknown {
  yield takeLatest(TActionType.justificativeStatusListRequest, sagaJustificativeStatusList);
}
